var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((this.searchInMenuItems(this.ItemsListAuthorized,_vm.searchOptModel)),function(it){return _c('a',{key:it.value,class:{
        'isDisabled': _vm.itemdisabled || it.ReadOnly,
        'rmActiveItem': !it.ReadOnly && _vm.active_element == it.value,
        'rm-optionssum': _vm.PatientSummary.includes(it.value),
        'blinkB4': _vm.hasNotification(it.value),  // Nueva clase condicional
        'show-before':_vm.NoBlueFirst
        },style:(_vm.Style),attrs:{"id":it.value},on:{"click":function($event){return _vm.triggerClick(it.value,it.text,it.href, $event,it.ReadOnly)}}},[_vm._v(" "+_vm._s(it.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }